module.exports = __webpack_public_path__ + "b479027a2f7426b09b143193909e2c40.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-9.png
// module id = 2116
// module chunks = 0